import { motion } from "framer-motion";

export const splitText = (text) =>
  text.split("").map((char, index) => (
    <motion.span
      key={`${char}-${index}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      style={{ display: "inline-block" }}
    >
      {char}
    </motion.span>
  ));
